import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";
import { InputRHFV2 } from "../../Atoms/InputsRHF/InputRHFV2";
import { SelectRHFV2 } from "../../Atoms/SelectsRHF/SelectRHFV2";
import { MessageErroFormV2 } from "../../Atoms/MessageErroFormV2";
import { ButtonV2 } from "../../Atoms/ButtonV2";
import { TipoVeiculoEnum, getTipoVeiculoLabel } from "../../../enums/tipoVeiculo";
import {
  IFormVehicleRegisterV2Values,
  useFormVehicleRegisterV2,
} from "./useFormVehicleRegisterV2";

const tipoOptions = Object.values(TipoVeiculoEnum)
  .filter((tipo) => tipo !== TipoVeiculoEnum.UNDEFINED)
  .map((tipo) => ({
    value: tipo,
    label: getTipoVeiculoLabel(tipo),
  }));

interface IFormVehicleRegisterV2Props extends ComponentProps<"form"> {
  onSubmitForm: (data: IFormVehicleRegisterV2Values) => void;
}

export const FormVehicleRegisterV2 = ({
  onSubmitForm,
  className,
  ...rest
}: IFormVehicleRegisterV2Props) => {
  const { register, handleSubmit, errors } = useFormVehicleRegisterV2();

  return (
    <form
      {...rest}
      onSubmit={handleSubmit(onSubmitForm)}
      className={twMerge(
        "flex w-full flex-col items-start gap-8 rounded-[10px] border border-solid border-[#e5e5ea] bg-white p-8 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)]",
        className,
      )}
    >
      <div className="flex w-full flex-col gap-8 sm:flex-row">
        <div className="w-full">
          <InputRHFV2 id="modelo" label="Modelo do veículo*" {...register("modelo")} />
          {errors?.modelo && (
            <MessageErroFormV2>{errors.modelo.message}</MessageErroFormV2>
          )}
        </div>
        <div className="w-full">
          <InputRHFV2 id="ano" label="Ano*" inputMode="numeric" {...register("ano")} />
          {errors?.ano && (
            <MessageErroFormV2>{errors.ano.message}</MessageErroFormV2>
          )}
        </div>
        <div className="w-full">
          <InputRHFV2 id="placa" label="Placa" {...register("placa")} />
          {errors?.placa && (
            <MessageErroFormV2>{errors.placa.message}</MessageErroFormV2>
          )}
        </div>
      </div>

      <div className="flex w-full flex-col gap-8 sm:flex-row">
        <div className="w-full">
          <InputRHFV2 id="chassi" label="Chassi*" {...register("chassi")} />
          {errors?.chassi && (
            <MessageErroFormV2>{errors.chassi.message}</MessageErroFormV2>
          )}
        </div>
        <div className="w-full">
          <SelectRHFV2
            id="tipo"
            label="Tipo de Veículo*"
            placeholder="Selecione"
            options={tipoOptions}
            {...register("tipo")}
          />
          {errors?.tipo && (
            <MessageErroFormV2>{errors.tipo.message}</MessageErroFormV2>
          )}
        </div>
      </div>

      <ButtonV2 type="submit" className="shrink-0">
        <img src="/assets/svgs/icon-add-white.svg" alt="" className="h-3.5 w-3.5" />
        Cadastrar
      </ButtonV2>
    </form>
  );
};
